import { createAction } from 'redux-actions'

import * as constants from './constants'

// Org level actions
export const fetchAssistantOrgSettings = createAction(constants.FETCH_ASSISTANT_ORG_SETTINGS)
export const fetchAssistantOrgSettingsPending = createAction(constants.FETCH_ASSISTANT_ORG_SETTINGS_PENDING)
export const fetchAssistantOrgSettingsSuccess = createAction(constants.FETCH_ASSISTANT_ORG_SETTINGS_SUCCESS)
export const fetchAssistantOrgSettingsFailed = createAction(constants.FETCH_ASSISTANT_ORG_SETTINGS_FAILED)

export const createAssistantOrgSettings = createAction(constants.CREATE_ASSISTANT_ORG_SETTINGS)
export const createAssistantOrgSettingsPending = createAction(constants.CREATE_ASSISTANT_ORG_SETTINGS_PENDING)
export const createAssistantOrgSettingsSuccess = createAction(constants.CREATE_ASSISTANT_ORG_SETTINGS_SUCCESS)
export const createAssistantOrgSettingsFailed = createAction(constants.CREATE_ASSISTANT_ORG_SETTINGS_FAILED)

export const patchAssistantOrgSettings = createAction(constants.PATCH_ASSISTANT_ORG_SETTINGS)
export const patchAssistantOrgSettingsPending = createAction(constants.PATCH_ASSISTANT_ORG_SETTINGS_PENDING)
export const patchAssistantOrgSettingsSuccess = createAction(constants.PATCH_ASSISTANT_ORG_SETTINGS_SUCCESS)
export const patchAssistantOrgSettingsFailed = createAction(constants.PATCH_ASSISTANT_ORG_SETTINGS_FAILED)

// Agent level actions
export const fetchAssistantAgentSettings = createAction(constants.FETCH_ASSISTANT_AGENT_SETTINGS)
export const fetchAssistantAgentSettingsPending = createAction(
  constants.FETCH_ASSISTANT_AGENT_SETTINGS_PENDING
)
export const fetchAssistantAgentSettingsSuccess = createAction(
  constants.FETCH_ASSISTANT_AGENT_SETTINGS_SUCCESS
)
export const fetchAssistantAgentSettingsFailed = createAction(constants.FETCH_ASSISTANT_AGENT_SETTINGS_FAILED)

export const createAssistantAgentSettings = createAction(constants.CREATE_ASSISTANT_AGENT_SETTINGS)
export const createAssistantAgentSettingsPending = createAction(
  constants.CREATE_ASSISTANT_AGENT_SETTINGS_PENDING
)
export const createAssistantAgentSettingsSuccess = createAction(
  constants.CREATE_ASSISTANT_AGENT_SETTINGS_SUCCESS
)
export const createAssistantAgentSettingsFailed = createAction(
  constants.CREATE_ASSISTANT_AGENT_SETTINGS_FAILED
)

export const patchAssistantAgentSettings = createAction(constants.PATCH_ASSISTANT_AGENT_SETTINGS)
export const patchAssistantAgentSettingsPending = createAction(
  constants.PATCH_ASSISTANT_AGENT_SETTINGS_PENDING
)
export const patchAssistantAgentSettingsSuccess = createAction(
  constants.PATCH_ASSISTANT_AGENT_SETTINGS_SUCCESS
)
export const patchAssistantAgentSettingsFailed = createAction(constants.PATCH_ASSISTANT_AGENT_SETTINGS_FAILED)

// Salesforce settings
export const fetchSalesforceSettings = createAction(constants.FETCH_SALESFORCE_SETTINGS)
export const fetchSalesforceSettingsPending = createAction(constants.FETCH_SALESFORCE_SETTINGS_PENDING)
export const fetchSalesforceSettingsSuccess = createAction(constants.FETCH_SALESFORCE_SETTINGS_SUCCESS)
export const fetchSalesforceSettingsFailed = createAction(constants.FETCH_SALESFORCE_SETTINGS_FAILED)

// Personalization tags
export const fetchPersonalizationTags = createAction(constants.FETCH_PERSONALIZATION_TAGS)
export const fetchPersonalizationTagsPending = createAction(constants.FETCH_PERSONALIZATION_TAGS_PENDING)
export const fetchPersonalizationTagsSuccess = createAction(constants.FETCH_PERSONALIZATION_TAGS_SUCCESS)
export const fetchPersonalizationTagsFailed = createAction(constants.FETCH_PERSONALIZATION_TAGS_FAILED)

// editing state actions
export const handleEditConfig = createAction(constants.SET_INITIAL_ORG_EDIT_STATE)

export const setInitial = createAction(constants.SET_INITIAL)
export const onUpdate = createAction(constants.ON_UPDATE)
export const onWarmLeadUpdate = createAction(constants.ON_WARM_LEAD_UPDATE)
export const onWarmLeadUpdateTemplate = createAction(constants.ON_WARM_LEAD_UPDATE_TEMPLATE)
export const onCancel = createAction(constants.ON_CANCEL)


export const sendTestEmail = createAction(constants.SEND_TEST_EMAIL)
export const sendTestEmailPending = createAction(constants.SEND_TEST_EMAIL_PENDING)
export const sendTestEmailSuccess = createAction(constants.SEND_TEST_EMAIL_SUCCESS)
export const sendTestEmailFailed = createAction(constants.SEND_TEST_EMAIL_FAILED)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/assistantSettings/actions.js